module.exports = __webpack_public_path__ + "img/01web-other.8367785d.png";